export const SERVER_URL = import.meta.env.VITE_SERVER_URL || ''

/** R2 存储公开访问基址（含 server-data 路径前缀）。为空时回退到 SERVER_URL 走 VPS */
export const STORAGE_BASE = import.meta.env.VITE_STORAGE_BASE || ''
